import React, { useState, useEffect } from 'react';
import { NotificationContainer } from 'react-notifications';
import TopMenu from "../components/TopMenu/TopMenu";
import styles from '../App.module.css';
// const express = require('express');
// const cors = require('cors');
// const app = express();

import axios from 'axios';

function Koommo() {

  var popup;

  auth();

  // 1. Opens window to grant access
  function auth() {
    popup = window.open('https://www.kommo.com/oauth/access_token?client_id=XXX&state=XXX&mode=post_message', 'Allow Access', 'scrollbars, status, resizable, width=750, height=580');
  }

  // 2. Registering a message handler from the popup window
  window.addEventListener('message', updateAuthInfo);

  // 3. The handler function registered above
  function updateAuthInfo(e) {
    if (e.data.error !== undefined) {
      console.log('Error - ' + e.data.error)
    } else {
      console.log('Authorization completed')
    }
    // 4. Closing the modal window
    // popup.close();
  }

  if (window.opener) {
    window.opener.postMessage({ 'error': undefined, 'status': 'ok' }, "*");
  }
  const [accessToken, setAccessToken] = useState(null);
  const [refreshToken, setRefreshToken] = useState(null);

  // Passo 1: Obter Código de Autorização
  const getCodeOfAuthorization = () => {
    // Aqui você geraria o link de autorização e redirecionaria o usuário para ele
    window.location.href = 'https://www.kommo.com/oauth?client_id={Integration ID}&state={parameter of the state}&mode={popup or post_message}';
  };

  // Passo 2: Trocar Código de Autorização por Tokens de Acesso e Atualização
  const exchangeAuthorizationCode = async (authorizationCode) => {
    try {
      const response = await axios.post('https://agilizavisto.kommo.com/oauth2/access_token', {
        client_id: 'df863bb2-04a8-449b-8ad8-6c09ef39dc12',
        client_secret: 'Fr0jyiQa6UyK2YfDort0xZKDmUEtSLBXqP6M9HDLnI3mVz67z0qXkohnDnMS6Giv',
        grant_type: 'authorization_code',
        code: authorizationCode,
        redirect_uri: 'https://your-redirect-uri.com/'
      });
      setAccessToken(response.data.access_token);
      setRefreshToken(response.data.refresh_token);
    } catch (error) {
      console.error('Erro ao trocar o código de autorização por tokens:', error);
    }
  };

  // Passo 3: Fazer Requisições à API Utilizando Tokens de Acesso
  const makeApiRequest = async () => {
    try {
      const response = await axios.get('https://agilizavisto.kommo.com/api/v4/account', {
        headers: {
          'Authorization': `Bearer ${accessToken}`
        }
      });
      console.log('Resposta da API:', response.data);
    } catch (error) {
      console.error('Erro ao fazer requisição à API:', error);
    }
  };

  // Passo 4: Lidar com o Ciclo de Vida dos Tokens (opcional)

  return (
    <div>
      <button onClick={getCodeOfAuthorization}>Obter Código de Autorização</button>
      <button onClick={() => exchangeAuthorizationCode('authorization_code_here')}>
        Trocar Código de Autorização por Tokens
      </button>
      <button onClick={makeApiRequest}>Fazer Requisição à API</button>




    </div>
  );
};


export default Koommo;
